import { Theme } from '../types/theme-types';

export const space: Theme['space'] = {
  none: 0,
  xxxs: 2,
  xxs: 4,
  xs: 8,
  s: 16,
  m: 24,
  l: 32,
  xl: 40,
  xxl: 48,
  xxxl: 56,
  xxxxl: 64,
  auto: 'auto',
};
